import { render, staticRenderFns } from "./GruppoDistinteConsumiList.vue?vue&type=template&id=91fb3bc6&scoped=true"
import script from "./GruppoDistinteConsumiList.vue?vue&type=script&lang=ts"
export * from "./GruppoDistinteConsumiList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91fb3bc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91fb3bc6')) {
      api.createRecord('91fb3bc6', component.options)
    } else {
      api.reload('91fb3bc6', component.options)
    }
    module.hot.accept("./GruppoDistinteConsumiList.vue?vue&type=template&id=91fb3bc6&scoped=true", function () {
      api.rerender('91fb3bc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GruppoDistinteConsumiList.vue"
export default component.exports